// extracted by mini-css-extract-plugin
export default {"signatureContainer":"signatureContainer___XZQIR","signatureError":"signatureError___lSEFl","signatureActions":"signatureActions___sMLDf"};